import React from "react";
import styled from "styled-components";
import { GradientWord } from "../components/Headlines";

const StyledProblem = styled.section`
  background-color: ${(props) => props.theme.darkBg2};
  display: flex;
  justify-content: center;
  padding: 90px 30px;

  @media screen and (min-width: 800px) {
    padding: 120px 60px;
  }
`;

const Statement = styled.p`
  font-family: ${(props) => props.theme.regularFont};
  font-weight: 500;
  font-size: 26px;
  line-height: 1.45;
  text-align: center;
  color: ${(props) => props.theme.textColor};
  max-width: 820px;
  margin: 0;

  @media screen and (min-width: 800px) {
    font-size: 34px;
  }
`;

const Muted = styled.span`
  color: ${(props) => props.theme.textMuted};
`;

export default function Problem() {
  return (
    <StyledProblem>
      <Statement>
        <Muted>
          The usual agency experience: slow replies, a week's wait for a small
          change, work that comes back half-right.
        </Muted>{" "}
        We're the opposite - <GradientWord>fast</GradientWord>, responsive, and
        genuinely helpful, with people who know your site inside out.
      </Statement>
    </StyledProblem>
  );
}
